"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBadgeIconMarginPropByBadgeSize = exports.getBadgeFrameProps = void 0;

var _constants = require("./constants");

var getBadgeFramePaddingBySize = function getBadgeFramePaddingBySize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_SIZE_PROP;

  switch (size) {
    case 'xs':
      return '3px 8px 1px';

    case 'sm':
      return '5px 12px 3px';

    case 'rg':
    default:
      return _constants.DEFAULT_PADDING;
  }
};

var getBadgeFrameTextPropsBySize = function getBadgeFrameTextPropsBySize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_SIZE_PROP;
  var fontWeight = _constants.DEFAULT_FONT_WEIGHT;
  var fontSize;
  var lineHeight;
  var letterSpacing;

  switch (true) {
    case size === 'xs':
    case size === 'sm':
      fontSize = '12px';
      lineHeight = '18px';
      letterSpacing = '0.633px';
      break;

    case size === 'rg':
    default:
      fontSize = _constants.DEFAULT_FONT_SIZE;
      lineHeight = _constants.DEFAULT_LINE_HEIGHT;
      letterSpacing = _constants.DEFAULT_LETTER_SPACING;
  }

  return {
    fontSize: fontSize,
    fontWeight: fontWeight,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing
  };
};

var getBadgeFrameProps = function getBadgeFrameProps() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? _constants.DEFAULT_SIZE_PROP : _ref$size,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? _constants.DEFAULT_TYPE_PROP : _ref$type;

  var backgroundColor = _constants.DEFAULT_BACKGROUND_COLOR;
  var borderRadius = _constants.DEFAULT_BORDER_RADIUS;
  var padding = getBadgeFramePaddingBySize(size);

  var _getBadgeFrameTextPro = getBadgeFrameTextPropsBySize(size),
      fontSize = _getBadgeFrameTextPro.fontSize,
      lineHeight = _getBadgeFrameTextPro.lineHeight,
      letterSpacing = _getBadgeFrameTextPro.letterSpacing;

  switch (true) {
    case type === 'corner':
      borderRadius = '0px 0px 10px 0px';
      break;

    case type === 'placeholder':
      backgroundColor = '#E6E6E6';
      break;

    case type === 'success':
      backgroundColor = '#D5F2CA';
      break;

    case type === 'warning':
      backgroundColor = '#FFEAC4';
      break;

    case type === 'default':
    default:
  }

  return {
    backgroundColor: backgroundColor,
    borderRadius: borderRadius,
    padding: padding,
    fontSize: fontSize,
    lineHeight: lineHeight,
    letterSpacing: letterSpacing
  };
};

exports.getBadgeFrameProps = getBadgeFrameProps;

var getBadgeIconMarginPropByBadgeSize = function getBadgeIconMarginPropByBadgeSize() {
  var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _constants.DEFAULT_SIZE_PROP;

  switch (size) {
    case 'xs':
      return '0px 4px 0px 0px';

    case 'sm':
      return '0px 4px 0px -2px';

    case 'rg':
    default:
      return _constants.DEFAULT_ICON_MARGIN;
  }
};

exports.getBadgeIconMarginPropByBadgeSize = getBadgeIconMarginPropByBadgeSize;